import type { TableColumnSize } from '@cli-types/core-engine/schema.js'
import { getTableColumnSize } from './get-table-column-size.js'

export function buildColumnSize(size: TableColumnSize | undefined): string {
  return `size: ${getTableColumnSize(size)},\n    `
}
